import { addDays, addMonths, addWeeks, addYears, differenceInDays, differenceInMonths, differenceInYears, eachDayOfInterval, endOfWeek, isWeekend, isWithinInterval, startOfWeek, } from 'date-fns';
export function getWeeksDiff(startDate, endDate) {
    const msInWeek = 1000 * 60 * 60 * 24 * 7;
    return Math.round(Math.abs(endDate.valueOf() - startDate.valueOf()) / msInWeek);
}
export function getWeekDate(dayName) {
    const weekDay = {
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
    };
    const currentDay = weekDay[dayName];
    const date = new Date();
    var day = date.getDay();
    date.setHours(-24 * (day - currentDay));
    return date;
}
export function getFirstFriday(startDate) {
    var resultDate = startDate;
    resultDate.setDate(startDate.getDate() + ((7 + 5 - startDate.getDay()) % 7));
    return resultDate;
}
export function getPreviousAndNextMonths(currentDate, period) {
    const monthsAgo = new Date(currentDate);
    const monthsLater = new Date(currentDate);
    const previousDate = new Date(monthsAgo.setMonth(monthsAgo.getMonth() - period));
    const nextDate = new Date(monthsLater.setMonth(monthsLater.getMonth() + period));
    return { previousDate, nextDate };
}
export const monthsList = [
    { label: 'January', value: '1' },
    { label: 'February', value: '2' },
    { label: 'March', value: '3' },
    { label: 'April', value: '4' },
    { label: 'May', value: '5' },
    { label: 'June', value: '6' },
    { label: 'July', value: '7' },
    { label: 'August', value: '8' },
    { label: 'September', value: '9' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
];
export const getNextDateByDay = (daysLater, currentDate) => {
    const today = new Date();
    const date = new Date(currentDate || today);
    date.setDate(date.getDate() + daysLater);
    return date;
};
export function getAgeInYearsMonthsAndDays(birthdate) {
    const birthDateObj = new Date(birthdate);
    const currentDate = new Date();
    const years = differenceInYears(currentDate, birthDateObj);
    const afterYears = addYears(birthDateObj, years);
    const months = differenceInMonths(currentDate, afterYears);
    const afterMonths = addMonths(afterYears, months);
    const days = differenceInDays(currentDate, afterMonths);
    return { years, months, days };
}
export function numberToDayOfWeek(number, format) {
    const days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];
    let day = days[number];
    if (format === 'short') {
        day = day.substring(0, 3);
    }
    return day;
}
export function getFormattedDateInYearsMonthsAndDays(startedDate) {
    if (!startedDate)
        return undefined;
    const { years, months, days } = getAgeInYearsMonthsAndDays(startedDate);
    if (!years && !months && !days)
        return 'Not provided';
    if (years === 0 && months < 1) {
        return `${days} ${days > 1 ? 'days' : 'day'}`;
    }
    if (years === 0) {
        return `${months} ${months > 1 ? 'months' : 'month'}`;
    }
    return `${years} ${years > 1 ? 'years' : 'year'} ${months} ${months > 1 ? 'months' : 'month'}`;
}
export const getDateWithoutTimeZone = (date) => {
    if (!date)
        return;
    const [dateWithoutTimeZoneString] = date === null || date === void 0 ? void 0 : date.split('T');
    if (dateWithoutTimeZoneString) {
        const dateWithoutTimeZone = new Date(dateWithoutTimeZoneString);
        dateWithoutTimeZone.setHours(0, 0, 0, 0);
        return dateWithoutTimeZone;
    }
    return undefined;
};
export const getPreviousMonth = (date) => {
    const currentMonth = date.getMonth();
    const currentYear = date.getFullYear();
    let previousMonth = currentMonth - 1;
    let previousYear = currentYear;
    if (previousMonth < 0) {
        previousMonth = 11;
        previousYear -= 1;
    }
    return new Date(previousYear, previousMonth, 1);
};
export const getNextMonth = (date) => {
    const currentMonth = date.getMonth();
    const currentYear = date.getFullYear();
    let nextMonth = currentMonth + 1;
    let nextYear = currentYear;
    if (nextMonth > 11) {
        nextMonth = 0;
        nextYear += 1;
    }
    return new Date(nextYear, nextMonth, 1);
};
export const getBusinessDaysOfWeek = (startDate) => {
    const startOfWeekDate = startOfWeek(startDate, { weekStartsOn: 1 });
    const endOfWeekDate = endOfWeek(startDate, { weekStartsOn: 1 });
    const allDays = eachDayOfInterval({
        start: startOfWeekDate,
        end: endOfWeekDate,
    });
    const businessDays = allDays.filter((day) => !isWeekend(day));
    return businessDays;
};
export const isNextWeek = (date) => {
    const startOfNextWeek = startOfWeek(addWeeks(new Date(), 1));
    const endOfNextWeek = endOfWeek(addWeeks(new Date(), 1));
    return isWithinInterval(date, { start: startOfNextWeek, end: endOfNextWeek });
};
export const getNextBusinessDay = (date) => {
    let nextDay = addDays(date, 1);
    while (isWeekend(nextDay)) {
        nextDay = addDays(nextDay, 1);
    }
    return nextDay;
};
//# sourceMappingURL=date.utils.js.map